import StickyFooter from '@/components/v1/StickyFooter'
import { useTranslation } from 'react-i18next'
import { Form } from 'react-router-dom'

interface Props {
  emoji: string
  titleKey: string
}

export default function StatementStep({ emoji, titleKey }: Props) {
  const { t } = useTranslation()

  return (
    <div className="flex grow flex-col pt-2">
      <div className="flex grow flex-col items-center justify-center gap-6 py-10">
        <span
          aria-hidden
          className="bg-hw-primary-soft animate-scale-in flex h-20 w-20 items-center justify-center rounded-full text-4xl"
        >
          <span className="animate-float">{emoji}</span>
        </span>

        <div className="hw-card animate-fade-up flex w-full flex-col items-center p-5 [animation-delay:120ms]">
          <svg
            aria-hidden
            className="text-hw-primary mb-3 h-6 w-6"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path d="M9.6 6C6.5 7.3 4.5 10 4.5 13.4V18h5.6v-5.6H7.3c.1-1.9 1.2-3.5 3.2-4.4L9.6 6Zm9 0c-3.1 1.3-5.1 4-5.1 7.4V18h5.6v-5.6h-2.8c.1-1.9 1.2-3.5 3.2-4.4L18.6 6Z" />
          </svg>

          <p className="text-hw-ink text-center text-[17px] leading-snug font-semibold text-balance">
            {t(titleKey)}
          </p>
        </div>
      </div>

      <Form method="post">
        <input
          name={t(titleKey, { lng: 'en' })}
          type="hidden"
          value={t('shared.continue', { lng: 'en' })}
        />

        <StickyFooter>
          <button className="hw-button-primary" type="submit">
            {t('shared.continue')}
          </button>
        </StickyFooter>
      </Form>
    </div>
  )
}
